enum BreadcrumbType {
  DEFAULT = 'default',
  HTTP = 'http',
  NAVIGATION = 'navigation',
  USER = 'user',
}

enum BreadcrumbCategory {
  CONSOLE = 'console',
  NAVIGATION = 'navigation',
  UI_CLICK = 'ui.click',
  CUSTOM = 'custom',
}

export { BreadcrumbType, BreadcrumbCategory };
